import React from "react";
import { IconEdit, IconTrash } from "./Icons";

/**
 * TemplateCard Component
 * Displays a single template card with edit/delete/assign actions
 * Props:
 * - template: Template object with { _id, title, description }
 * - isAssigned: Boolean indicating if template is assigned to company
 * - isAssigning: Loading state for assign action
 * - isUnassigning: Loading state for unassign action
 * - isLoadingTemplate: Loading state for edit action
 * - onEdit: Callback when edit button clicked
 * - onDelete: Callback when delete button clicked
 * - onAssign: Callback when assign button clicked
 * - onUnassign: Callback when unassign button clicked
 * - onViewAnswers: Callback when view answers button clicked
 */
export default function TemplateCard({
  template,
  isAssigned,
  isAssigning,
  isUnassigning,
  isLoadingTemplate,
  onEdit,
  onDelete,
  onAssign,
  onUnassign,
  onViewAnswers,
}) {
  return (
    <div className="cd-diagnostic-card">
      <div className="cd-card-icons">
        <button
          className="cd-icon-btn cd-edit-icon"
          onClick={() => onEdit?.(template)}
          disabled={isLoadingTemplate}
          title="Edit"
        >
          <IconEdit />
        </button>
        <button
          className="cd-icon-btn cd-delete-icon"
          onClick={() => onDelete?.(template)}
          title="Delete"
        >
          <IconTrash />
        </button>
      </div>
      <div className="cd-diagnostic-head">
        <div className="cd-diagnostic-title">{template.title}</div>
      </div>
      <div className="cd-diagnostic-desc">
        {template.description || "No description provided."}
      </div>
      <div className="cd-diagnostic-actions">
        {isAssigned ? (
          <button
            className="cd-assign-btn"
            style={{ backgroundColor: '#dc3545' }}
            onClick={() => onUnassign?.(template._id)}
            disabled={isUnassigning}
          >
            Unassign
          </button>
        ) : (
          <button
            className="cd-assign-btn"
            onClick={() => onAssign?.(template._id)}
            disabled={isAssigning}
          >
            Assign →
          </button>
        )}
        <button
          className="cd-open-btn"
          onClick={() => onViewAnswers?.(template._id)}
        >
          View Answers →
        </button>
      </div>
    </div>
  );
}
